/**
 * Sri Lankan NIC Processor Utility
 * 
 * Rules:
 * 1. Old NIC: 10 chars (e.g. 941234567V). New NIC: 12 digits (e.g. 199412345678).
 * 2. Birth Year: Old NIC starts with 19XX (first 2 digits). New NIC is full 4 digits.
 * 3. Day of Year (DDD): Old (3-5), New (5-7).
 * 4. Gender: DDD > 500 is Female (subtract 500).
 * 5. SL NIC logic usually treats all years as 366 days (Feb has 29).
 */

export const processNIC = (nic) => {
  if (!nic) return { error: "Invalid NIC number" };

  let year, days, gender;
  const nicStr = nic.toString().trim().toUpperCase();

  // Validate and Extract
  if (nicStr.length === 10 && /^[0-9]{9}[VX]$/.test(nicStr)) {
    // Old NIC
    year = 1900 + parseInt(nicStr.substring(0, 2));
    days = parseInt(nicStr.substring(2, 5));
  } else if (nicStr.length === 12 && /^[0-9]{12}$/.test(nicStr)) {
    // New NIC
    year = parseInt(nicStr.substring(0, 4));
    days = parseInt(nicStr.substring(4, 7));
  } else {
    return { error: "Invalid NIC number" };
  }

  // Determine Gender
  if (days > 500) {
    gender = "Female";
    days -= 500;
  } else {
    gender = "Male";
  }

  // Day of year must be between 1 and 366
  if (days < 1 || days > 366) {
    return { error: "Invalid NIC number" };
  }

  // Convert days to Date (Assuming 366 days as per SL standard)
  const monthDays = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  let month = 0, date = 0;
  let accumulatedDays = 0;

  for (let i = 0; i < monthDays.length; i++) {
    if (days <= accumulatedDays + monthDays[i]) {
      month = i + 1;
      date = days - accumulatedDays;
      break;
    }
    accumulatedDays += monthDays[i];
  }

  // Format YYYY-MM-DD
  const formattedMonth = month.toString().padStart(2, '0');
  const formattedDate = date.toString().padStart(2, '0');
  const dob = `${year}-${formattedMonth}-${formattedDate}`;

  return {
    gender: gender,
    date_of_birth: dob
  };
};
